(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-ethnicity', {
                parent: 'entity',
                url: '/type-ethnicity',
                data: {
                    authorities: [],
                    pageTitle: 'TypeEthnicities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-ethnicity/list/type-ethnicity.html',
                        controller: 'TypeEthnicityController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Ethnicity Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY, access);
                }]
            });
    }
})();
